// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gROnF","title":"styles_title__pXwmn","body":"styles_body__eLCvb","children":"styles_children__hKoOO"};